(function() {

    'use strict';

    angular.module('Services')
        .factory('MarketPlaceService', MarketPlaceService);

    MarketPlaceService.$inject = ['$http', 'Error', 'Request'];

    function MarketPlaceService($http, Error, Request) {

        var service = {
                get             : _get,
                getAnnualReport : _getAnnualReport,
                getConfiguration: _getConfiguration
            };

        return service;

        function _getAnnualReport(callback, errCallback, data) {
            Request.get({
                url            : ApiURLs.marketPlace.annualReport,
                successCallback: callback,
                errorCallback  : errCallback,
                data           : data
            });
        }
        /**
         *
         * @param {string} id - marketPlace ID
         * @param {function} successCallback - is performed after a successful request
         * @param {function} errorCallback - is performed after the request with error
         */
        function _get(id, callback, errCallback) {
            Request.get({
                url            : ApiURLs.marketPlace.list + id,
                successCallback: callback,
                errorCallback  : errCallback
            });
        }

        function _getConfiguration(callback, errCallback, data) {
            Request.get({
                url            : ApiURLs.marketPlace.list,
                successCallback: callback,
                errorCallback  : errCallback,
                data           : data
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/MarketPlaceService.js